/**
 * Created by mariushirjanu on 12/06/2020.
 */
import { Injectable, OnDestroy } from '@angular/core';
import { of, Observable, Subscription } from 'rxjs';
import { TranslateLoader } from '@ngx-translate/core';
import { GaEventService, IGAEvent } from '../services/ga-event.service';
import { EVENT_TRANSLATION_UPDATED } from '../app-events';
import { IObject } from '../../../type_definitions/datatypes';

@Injectable()
export class TranslationLoaderService implements TranslateLoader, OnDestroy {
  private eventHandler:Subscription;
  private translations:IObject = {};

  constructor(
    private eventService:GaEventService
  ) {
    this.listen();
  }

  private listen():void {
    this.eventHandler = this.eventService.events?.subscribe((event:IGAEvent):void => {
      if(event.name === EVENT_TRANSLATION_UPDATED){
        this.translations = event.data.translations;
      }
    });
  }

  public getTranslation():Observable<{}> {
    return of(this.translations);
  }

  public ngOnDestroy():void {
    this.eventHandler?.unsubscribe();
  }
}